import React, { useRef, useState } from "react";
import { MapContainer, TileLayer, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import Button from "react-bootstrap/Button";

import LocationModal from "./LocationModal";
import {showSuccess, showWarning, showError} from "../../../utils/toastHelper";
import Header from "../../../layouts/Header";
import {BiTargetLock} from "react-icons/bi";
import {LuMapPinOff} from "react-icons/lu";
import {TbMapPinCheck} from "react-icons/tb";
import {storeAddress} from "../api/AddressAPI";


// نمایش مارکر وسط نقشه با CSS (آیکون بی‌نیاز از leaflet مارکر است)
const CenterMarker = () => (
    <div className="center-marker">
        <svg width="40" height="40" fill="blue" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="10" fill="blue" stroke="orange" strokeWidth="1"/>
            <circle cx="16" cy="16" r="4" fill="orange"/>
        </svg>
    </div>
);

const AddAddress = () => {
    const mapRef = useRef();
    const [center, setCenter] = useState({ lat: 36.3153239, lng: 59.5380047 }); // مختصات
    const [modalShow, setModalShow] = useState(false);
    const [withoutLocation, setWithoutLocation] = useState(false);

    // هندل جابجایی نقشه و ثبت مختصات مرکز
    function MapEventHandler() {
        useMapEvents({
            moveend: (e) => {
                const map = e.target;
                const { lat, lng } = map.getCenter();
                setCenter({ lat, lng });
            },
        });
        return null;
    }

    // هندل دکمه "موقعیت من"
    const handleLocate = () => {
        if (!navigator.geolocation) {
            showWarning("مرورگر شما از موقعیت‌یابی پشتیبانی نمی‌کند.");
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const { latitude, longitude } = pos.coords;
                setCenter({ lat: latitude, lng: longitude });
                // مرکز نقشه را هم با ref جابجا کن
                if (mapRef.current) {
                    mapRef.current.setView([latitude, longitude]);
                }
            },
            (err) => {
                showWarning("متاسفانه موقعیت شما پیدا نشد. لطفا آن را به صورت خودتان روی نقشه مشخص کنید.");
            },
            { enableHighAccuracy: true }
        );
    };

    // هندل ثبت اطلاعات آدرس

    const handleRegisterAddress = async (data) => {
        try {

            const request = {
                ...data,
                lat: withoutLocation ? 0 : center.lat,
                long: withoutLocation ? 0 : center.lng,

            }
            const result = await storeAddress(request);

            showSuccess(result.message );
            setTimeout (() => {

                window.history.back()
            },1500)


        } catch (error) {
            console.log(error)

            if (error.response) {
                showError(error.response.data.message || "امکان ثبت آدرس  وجود ندارد");
            } else {
                showError("خطا در ارتباط با سرور.");
            }
        }



    }

    return (
        <div className="location-wrapper position-relative " style={{height: '95vh'}}>
            <Header title='   افزودن آدرس جدید  ' hasBack={true} />
            <MapContainer
                center={[center.lat, center.lng]}
                zoom={14}
                ref={(ref) => {
                    if (ref) mapRef.current = ref;
                }}
                style={{ height: "100vh", width: "100%" }}
                className="rounded shadow"
            >
                <TileLayer
                    // tile provider آزاد و بدون محدودیت: openstreetmap
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <MapEventHandler />
            </MapContainer>
            <CenterMarker />

            <Button
                className="my-location-btn"
                variant="light"
                onClick={handleLocate}
            >
                <BiTargetLock className='mx-2' />
                موقعیت من
            </Button>


            <div className='fixed-bottom bg-white p-2 row mobile-size-option'>
                <div className="col-7">
                    <Button
                        className="submit-location-btn bg-primary-color rounded text-white"
                        variant="warning"
                        onClick={() => {
                            setWithoutLocation(false)
                            setModalShow(true)
                        } }
                    >
                        <TbMapPinCheck className='mx-2 text-big-4 '/>
                        انتخاب و ادامه
                    </Button>
                </div>
                <div className="col-5">
                    <Button
                        className="submit-location-btn  rounded text-white"
                        variant="secondary"
                        onClick={() => {
                            setWithoutLocation(true)
                            setModalShow(true)
                        } }
                    >
                        <LuMapPinOff className='mx-2 text-big-4 '/>
                        ثبت  دستی
                    </Button>
                </div>

            </div>

            <LocationModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                onSubmit={handleRegisterAddress}
                withoutLocation = {withoutLocation}
            />
        </div>
    );
};

export default AddAddress;
